import React, { PropsWithChildren } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./MasterLayoutStyles.scss";
import { StepId } from "logic/Navigation/Steps";
import { Header } from "components/layout/Header";
import { Footer } from "components/layout/Footer";
import { MicrositeContactDetails } from "generated/types/types";
import { ToastContainer, Slide } from "react-toastify";


interface Props {
    currentStep: StepId;
    setCurrentStep: (stepId: StepId) => void;
    contactDetails: MicrositeContactDetails;
    isBookingCreationJourney: boolean;
    headerImageBlobGuid: string | null;
    favIconBlobGuid: string | null;
    micrositePin: string;
    footerImageBlobGuid: string | null;
    footerStraplineText: string | null;
    customCompanyName : string ;
}

export const MasterLayout: React.FC<PropsWithChildren<Props>> = props => {
    return (
        <div className="master-layout">
            <div className="body-footer-container">
                <Header
                    contactDetails={props.contactDetails}
                    currentStep={props.currentStep}
                    setCurrentStep={props.setCurrentStep}
                    isBookingCreationJourney={props.isBookingCreationJourney}
                    headerImageBlobGuid={props.headerImageBlobGuid}
                    favIconBlobGuid={props.favIconBlobGuid}
                    customCompanyNames={props.customCompanyName}
                   
                />
                <div className="container">
                    <ToastContainer transition={Slide} />
                    <div className="body-container">{props.children}</div>
                </div>
            </div>
            <Footer micrositePin={props.micrositePin} footerStraplineText={props.footerStraplineText} footerImageBlobGuid={props.footerImageBlobGuid} />
        </div>
    );
};
